import { render } from "./PlacementZoneClasses.vue?vue&type=template&id=fe5463ee&scoped=true"
import script from "./PlacementZoneClasses.vue?vue&type=script&lang=js"
export * from "./PlacementZoneClasses.vue?vue&type=script&lang=js"

import "./PlacementZoneClasses.vue?vue&type=style&index=0&id=fe5463ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5463ee"]])

export default __exports__